var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Toast } from "../../elements/Toast";
import { Text } from "../../elements/Text";
export function EmailConfirmationToast(_a) {
    var isOpen = _a.isOpen, onDismiss = _a.onDismiss;
    return (_jsx(Toast, { open: isOpen, color: "forest", onDimiss: onDismiss, autoHideDuration: 10000, message: _jsx(Text, __assign({ textStyle: "body1", color: "white" }, { children: "E-mail reenviado." })) }));
}
